import dynamic from 'next/dynamic';

import { IFrameProps } from './IFrame.types';

export const IFrame = dynamic<IFrameProps>(() => import('./IFrame').then(module => module.IFrame));
